// 이벤트 라이프사이클 액션 — start / revert / delete / archive / unarchive.
//
// 각 액션은 confirm 프롬프트 → API 호출 → toast + rerender 흐름.
// 시작/되돌리기/숨김 후 화면 갱신은 `onChanged` 콜백으로 호출자(라우터/페이지)가
// 결정. 삭제만은 다음 라우트가 달라질 수 있어 `onDeleted`로 분리.

import { api } from "../api";
import { toast, withBusy } from "../ui/sheet";

export interface LifecycleCallbacks {
  onChanged: () => void;
}

export interface DeleteCallbacks {
  onDeleted: () => void;
}

export async function startEvent(
  eventId: string,
  btn: HTMLButtonElement | null,
  cbs: LifecycleCallbacks,
): Promise<void> {
  if (!confirm("일정을 시작할까요?")) return;
  try {
    await withBusy(btn, "시작 중…", () =>
      api(`/api/v1/events/${eventId}/start`, { method: "POST", body: {} }),
    );
    toast("일정을 시작했어요");
    cbs.onChanged();
  } catch (e: any) {
    if (e.code === "INVALID_EVENT_STATUS") toast("먼저 참가자/스케줄을 준비해주세요");
    else toast(e.message);
  }
}

export async function revertEventToReady(
  eventId: string,
  btn: HTMLButtonElement | null,
  cbs: LifecycleCallbacks,
): Promise<void> {
  if (!confirm("일정을 준비 완료 상태로 되돌릴까요?\n참가자 · 스케줄은 그대로 유지돼요.")) return;
  try {
    await withBusy(btn, "되돌리는 중…", () =>
      api(`/api/v1/events/${eventId}/revert-to-ready`, { method: "POST", body: {} }),
    );
    toast("준비 완료 상태로 돌렸어요");
    cbs.onChanged();
  } catch (e: any) {
    if (e.code === "MATCH_RESULTS_EXIST") toast("이미 입력된 경기 결과가 있어요");
    else toast(e.message);
  }
}

export async function deleteEvent(
  ev: any,
  btn: HTMLButtonElement | null,
  cbs: DeleteCallbacks,
): Promise<void> {
  const title = ev.title || "이 일정";
  if (!confirm(`'${title}' 일정을 삭제할까요?\n참가자·스케줄 정보가 모두 사라지고 복구할 수 없어요.`)) return;
  try {
    await withBusy(btn, "삭제 중…", () =>
      api(`/api/v1/events/${ev.event_id}`, { method: "DELETE" }),
    );
    toast("일정을 삭제했어요");
    cbs.onDeleted();
  } catch (e: any) { toast(e.message); }
}

export async function archiveEvent(
  eventId: string,
  btn: HTMLButtonElement | null,
  cbs: LifecycleCallbacks,
): Promise<void> {
  if (!confirm("이 일정을 목록에서 숨길까요?\n기록은 남아있고 언제든 복원할 수 있어요.")) return;
  try {
    await withBusy(btn, "숨기는 중…", () =>
      api(`/api/v1/events/${eventId}/archive`, { method: "POST", body: {} }),
    );
    toast("일정을 숨겼어요");
    cbs.onChanged();
  } catch (e: any) { toast(e.message); }
}

export async function unarchiveEvent(
  eventId: string,
  btn: HTMLButtonElement | null,
  cbs: LifecycleCallbacks,
): Promise<void> {
  try {
    await withBusy(btn, "해제 중…", () =>
      api(`/api/v1/events/${eventId}/unarchive`, { method: "POST", body: {} }),
    );
    toast("숨김을 해제했어요");
    cbs.onChanged();
  } catch (e: any) { toast(e.message); }
}
